import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventType } from '@azure/msal-browser';
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
  SearchType,
  SliderType
} from '@cvx/nextpage';
import { AuthAPIMService } from './services/authAPIMService/authAPIM.service';
import { appVersion } from '../environments/version';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class AppComponent implements OnInit {
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  SearchType = SearchType;
  SliderType = SliderType;
  appVersion: string = appVersion;

  constructor
  (
    private NP: NextPageService, 
    private msalService: MsalService,
    private authAPIMService: AuthAPIMService
  ) {
    this.NP.options.sitename = 'WellView Tools App';
  }

  ngOnInit(): void {
    // Ensure MSAL is initialized before calling any API
    const msalInstance = this.msalService.instance;

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event) => {
      // set active account after redirect
      if (event.eventType === EventType.LOGIN_SUCCESS && (event.payload as AuthenticationResult)?.account) {
        const account = (event.payload as any).account;
        msalInstance.setActiveAccount(account);
      }
    });

    this.authAPIMService.refreshAccount();

    // handle auth redired/do all initial setup for msal
    this.msalService.handleRedirectObservable().subscribe({
      next: (authResult) => {
        // Check if user signed in 
        const account = msalInstance.getActiveAccount();
        if(!account){
          // redirect anonymous user to login page 
          msalInstance.loginRedirect();
        }
      },
      error: (err) => {
        // TODO: Handle errors
        console.log(err);
      }
    });
  }
}
